import React from 'react';
import { SubmitButton } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { FetchState } from '../../../hooks/reducers/useFetchReducer';
import { AxiosError, AxiosResponse } from 'axios';
import { SonResponseError } from '../../../_lib/Form2/types/SonResponseError';

export function TicketAddModalSubmitButton({ fetchState }: {
  fetchState: FetchState<AxiosResponse<any, any, object>, AxiosError<SonResponseError, any>>
}) {
  const { t } = useSonTranslation('TicketBooking');

  return (
    <SubmitButton
      buttonLabel={t('edit.form.saveButton')}
      messageFail={t('edit.form.status.fail')}
      messageSuccess={t('edit.form.status.success')}
      messageSending={t('edit.form.status.sending')}
      fetchState={fetchState}
      active={fetchState.type === 'initial'}
      customErrorTypeMessages={{
        maxCountExceeded: t('edit.form.status.maxCountExceeded'),
        invalidZeroCount: t('edit.form.status.invalidZeroCount'),
        ticketDurationInvalid: t('edit.form.status.ticketDurationInvalid'),
      }}
    />
  );
}
